import './resellersimscreen.styles.scss';
import { useSelector } from 'react-redux';
import { useContext, useState, useEffect, useCallback } from 'react';
import { SimContext } from '../../../api/SimContext';
import { IoMdSearch } from 'react-icons/io';
import Dropdown from '../../../components/dropdown/dropdown.component';
import { IoReloadCircleSharp } from 'react-icons/io5';
import { MdArrowBack, MdArrowForward } from 'react-icons/md';
import HeadingSecondary from '../../../components/typography/headings/heading-secondary/heading-secondary.component';

const ResellerSoldSimsScreen = ({ setSoldCount }) => {
  const { allSims, simToInv, reloadKey, setReloadKey, pageCount, setPageCount, fetchSimCardDataWithQuery } = useContext(SimContext);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredActiveSims, setFilteredActiveSims] = useState([]);
  const [selections, setSelections] = useState({});
  const [isSpinning, setIsSpinning] = useState(false);

  const handleReload = () => {
    setIsSpinning(true);
    setTimeout(() => {
      setReloadKey(reloadKey + 1);
      setIsSpinning(false);
    }, 1200);
  };

  // Debounce function to limit the number of API calls
  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

  // Fetch data when search term changes with debounce
  const fetchData = useCallback(
    debounce(async (searchTerm) => {
      const foundSims = await fetchSimCardDataWithQuery('ACTIVE', searchTerm);
      const filtered = foundSims.filter(sim => 
        sim.offerNameSnapshot !== "NO OFFER" && sim.tags && sim.tags.some(tag => tag.includes("Sold"))
      );
      setFilteredActiveSims(filtered);
    }, 300), // 300ms debounce
    [fetchSimCardDataWithQuery]
  );

  useEffect(() => {
    fetchData(searchTerm);
  }, [searchTerm, fetchData]);

  useEffect(() => {
    setSoldCount(filteredActiveSims.length);
  }, [filteredActiveSims.length, setSoldCount]);
  const calculateDaysPassed = (activationDate) => {
    const activation = new Date(activationDate);
    const now = new Date();
    const timeDiff = now - activation;
    return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  };

  const extractDurationAndActivationDate = (tags) => {
    const durationTags = tags
      .filter(tag => tag.startsWith('duration='))
      .map(tag => {
        const [duration, index] = tag.split('#index=');
        return { 
          duration: parseInt(duration.split('=')[1], 10), 
          index: parseInt(index, 10) 
        };
      });

    if (durationTags.length === 0) return { duration: null, activationDate: null };

    const highestDurationTag = durationTags.reduce((max, current) => current.index > max.index ? current : max, { duration: 0, index: -1 });

    const activationDateTag = tags.find(tag => tag.startsWith('activatedDate=') && tag.includes(`#index=${highestDurationTag.index}`));
    const activationDate = activationDateTag ? activationDateTag.split('=')[1].split('#')[0] : null;

    return { duration: highestDurationTag.duration, activationDate };
  };

  const handleBackClick = () => {
    if (pageCount > 0) {
      setPageCount(prevCount => prevCount - 1);
    }
  };

  const handleForwardClick = () => {
    setPageCount(prevCount => prevCount + 1);
  };

  return (
    <div className={'content-container-component'}>
      <div className="messages-container">
        <div className='table-heading-container'>
          <IoReloadCircleSharp size={28} color='black' onClick={handleReload} style={{ cursor: 'pointer'}} className={`reload-div ${isSpinning ? 'spin-animation' : ''}`} />
          {/* <div className='page-flip-container'>
            <MdArrowBack size={26} color='black' onClick={handleBackClick}/>
            <div className='page-flipper-text'>{pageCount + 1}</div>
            <MdArrowForward size={26} color='black' onClick={handleForwardClick}/>
          </div> */}
          <div className="search-container">
            <IoMdSearch size={28} color='#646272'/>
            <input 
              type="text" 
              className="search-input" 
              placeholder="Search SIM"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className='table-scroll-container'>
          <div className='panel-small'>
            <div className='panel-heading'> 
              <div className='inner-panel-heading'>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`MSISDN - SIM EID`} mode={'light'}/>
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Product`}mode={'light'}/>
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Duration`}mode={'light'}/>
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Action`}mode={'light'} />    
                </div>
              </div>
            </div>
            <div className='panel-content-container'>
              <div className='sim-heading-container'>
                <div className='sortby-container'>
                </div>
              </div>
              <div className='scroll-container'>
                {filteredActiveSims.map(sim => {
                  const { duration, activationDate } = extractDurationAndActivationDate(sim.tags);
                  const daysPassed = activationDate ? calculateDaysPassed(activationDate) : null;
                  return (
                    <div key={sim.eid} className="reseller-block-table">
                      <div className="sim-info-reseller">
                        <div className="sim-text-bold">{sim.msisdn}<br/>{sim.eid32}</div>
                      </div>
                      <div className="sim-info-reseller">
                        <div className="sim-text-bold">{sim.offerNameSnapshot}</div>
                      </div>
                      <div className='dropdown-container'>
                        <div className="duration-block">
                          <div className='sim-text'>
                            {activationDate ? `${daysPassed} / ${duration} days` : 'No activation date'}
                          </div>
                        </div>
                      </div>
                      <div className='sell-button-container' onClick={() => {
                        if (!selections[sim.id]?.sold) {
                          simToInv(sim.id);
                          setSelections(prev => ({
                            ...prev,
                            [sim.id]: {
                              ...prev[sim.id],
                              inv: true  
                            }
                          }));
                          setTimeout(() => {
                            setFilteredActiveSims(currentSims => currentSims.filter(s => s.id !== sim.id));
                          }, 800); 
                        } else {
                          console.log("SIM is already out of inventory."); 
                        }
                      }}>
                        <div className={`${selections[sim.id]?.inv ? 'loader' : 'sell-block'}`}> 
                          <div className='sim-text'>{selections[sim.id]?.inv ? '' : 'Set Inventory'}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResellerSoldSimsScreen;
